<template>
  <div data-component-group="filter-forms" data-component="tracking-advertisers" class="tracking-filters">
    <FiltersForm
      :has-filters="hasFilters"
      @filter="onFilter"
      @clear="onClearFilters"
      v-model="selectedCountries"
    >
      <v-text-field
        clearable
        v-model="search"
        type="search"
        label="Search"
        prepend-inner-icon="search"
        hide-details
      />

      <v-select
        v-model="status"
        :items="statuses"
        item-title="name"
        item-value="id"
        label="Status"
        hide-details
        variant="outlined"
        clearable
      />
    </FiltersForm>
  </div>
</template>

<script>
  import FiltersForm from './FiltersBase';
  import { isNonEmptyStr, isNonEmptyArr, isNum, escapeSearch } from '@/utils';
  import filterUrlSync from '@/mixins/filterUrlSync';

  // TODO: Translate component

  export default {
    mixins: [filterUrlSync],
    components: {
      FiltersForm,
    },
    emits: ['filter', 'clearFilters'],
    data() {
      return {
        urlConfig: [
          { field: 'search', urlKey: 'search', type: 'string' },
          { field: 'selectedCountries', urlKey: 'countries', type: 'string[]' },
          // The select stores the raw id (item-value="id"), so there is nothing
          // to look up: created() fills the options either way.
          { field: 'status', urlKey: 'status', type: 'number' },
        ],
        search: null,
        selectedCountries: [],
        status: null,
        statuses: [],
      };
    },
    computed: {
      hasFilters() {
        const { search, selectedCountries, status } = this;

        return isNonEmptyStr(search) || isNonEmptyArr(selectedCountries) || isNum(status)
      },
      countries() {
        return this.$store.getters['users/countries'];
      },
    },
    created() {
      this.$store.dispatch('tracking/getFilterStatuses').then((res) => {
        this.statuses = res;
      });
    },
    methods: {
      onFilter() {
        const { search, status } = this;
        const formattedSearch = escapeSearch(search);

        this.syncFiltersToUrl();

        this.$emit('filter', {
          search: formattedSearch,
          status,
          countries: this.selectedCountries,
        });
      },
      onClearFilters() {
        this.search = null;
        this.status = null;
        this.selectedCountries = [];

        this.clearFiltersUrl();

        this.$emit('clearFilters');
      },
    },
  };
</script>
